import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import UserEntity from "../../../../domain/entities/UserEntity";
import UserDto from "../../../dto/UserDto";

const SearchUsersForShiftApiImpl = async (_: { query?: string, scheduleId: string, date: Date }): Promise<Either<ErrorEntity, UserEntity[]>> => {
    try {
        let relativeUrl: string = `/turns/admin/available-valets?date=${_.date.toISOString().split('T')[0]}&schedule_id=${_.scheduleId}&`;

        if (_.query != undefined && _.query.length > 0) {
            relativeUrl += `name=${encodeURIComponent(_.query)}&`;
        }
        if (relativeUrl.endsWith('&') || relativeUrl.endsWith('?')) {
            relativeUrl = relativeUrl.slice(0, -1);
        }

        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);

        const parsed = response.available_valets.map((item: any) => UserDto.fromJSON(item));
        return right(parsed);
    } catch (error) {
        console.error("SearchUsersForShiftApiImpl error:", error);
        return left(ErrorEntityFromError(error));
    }
}

export default SearchUsersForShiftApiImpl;